import * as React from 'react';

import { ICategory } from '@shared/types/category';

import { IPackaging } from '@admin/types/packaging';

interface ICategorized {
  custom_category_name?: string;
  sizing_selection?: string;
  packaging?: IPackaging;
  category?: ICategory | null;

  customCategoryName?: string | null;
  sizingSelection?: string | null;

  partCategory?: {
    name: string;
  } | null;

  materialCategory?: {
    name: string;
  } | null;
}

export const Formatter: React.FC<{
  resource: ICategorized;
  fallback?: string;
}> = ({ resource, fallback }) => {
  if (!resource) {
    return fallback ? <>{fallback}</> : null;
  }
  const { category, packaging } = resource;

  const customCategoryName = resource.custom_category_name ?? resource.customCategoryName;
  const sizingSelection = resource.sizing_selection ?? resource.sizingSelection;
  const materialCategoryName =
    packaging?.material_category_name ?? packaging?.materialCategoryName ?? resource.materialCategory?.name;
  const partCategoryName = packaging?.part_category_name ?? packaging?.partCategoryName ?? resource.partCategory?.name;
  const sizingMetric = category?.sizing_metric ?? category?.sizingMetric;

  if (!category && materialCategoryName) return <>{materialCategoryName}</>;
  if (!category && partCategoryName) return <>{partCategoryName}</>;

  if (!category) {
    return fallback ? <>{fallback}</> : null;
  }

  if (customCategoryName) {
    return <>{customCategoryName} (Custom)</>;
  }
  if (!sizingSelection) {
    return <>{category.name}</>;
  }

  let summary = sizingSelection;
  if (sizingMetric && sizingMetric.unit) {
    summary += `-${sizingMetric.unit}`;
  }

  return (
    <>
      {category.name} ({summary})
    </>
  );
};
